import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SnackbarErrorService } from './snackbar-error.service';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  Window: any = window;

  constructor(
    private snackbarErrorService: SnackbarErrorService,
    public snackBar: MatSnackBar) {
  }

  public getListDDIWithFlagsDefault(): ListDDI[] {
    return [LIST_DDI[0]];
  }

  public getListDDIWithFlags(): ListDDI[] {
    return LIST_DDI;
  }

  public objectParams(queryParams) {
    let params = new HttpParams();
    Object.keys(queryParams).map(key => {
      if (queryParams[key]) {
        params = params.append(key, queryParams[key]);
      }
    });
    return params;
  }

  forceDownload(url: string, filename: string): Observable<string> {
    this.toast('Preparando o download', 'Aguarde');
    return new Observable<string>((observer) => {
      // Tenta fazer o download usando o método padrão (fetch + Blob)
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            this.toast('Erro ao fazer o download do arquivo.', 'error');
            throw new Error('Erro ao fazer o download do arquivo.');
          }
          return response.blob();
        })
        .then((blob) => {
          const urlBlob = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = urlBlob;
          anchor.setAttribute('download', filename);

          // Simula o clique para iniciar o download
          document.body.appendChild(anchor);
          anchor.click();

          // Remove o link temporário e o elemento âncora
          document.body.removeChild(anchor);
          window.URL.revokeObjectURL(urlBlob);

          // Emite um evento de sucesso
          observer.next('Download iniciado com sucesso');
          observer.complete();
        })
        .catch((error) => {
          console.error('Falha ao forçar o download:', error);

          // Fallback: Tenta abrir em uma nova aba ou janela (funciona em mobile)
          const newWindow = window.open(url, '_blank');

          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            // Se for bloqueada ou falhar, redireciona a janela atual para o arquivo
            window.location.href = url;
            observer.error('Pop-up bloqueado ou falha na abertura da nova aba. Redirecionando para a URL');
          } else {
            // Emite um evento de fallback para abrir em nova aba
            observer.next('Download iniciado em uma nova aba');
            observer.complete();
          }
        });
    });
  }

  /**
   * Set general error to toast
   */
  setErrorToast(err: any, msgForce: boolean = false, duration = 8000): void {
    const { error } = err;
    console.error(err);
    if (msgForce) {
      this.snackbarErrorService.open(err, 'Erro', duration);
      return;
    } else if (error) {
      const { message, status } = error;
      if (status === 404) {
        this.snackbarErrorService.open('Recurso não encontrado', 'Erro', duration);
        return;
      }
      if (message) {
        this.snackbarErrorService.open(message, 'Erro', duration);
        return;
      }
    } else {
      const { status } = err;
      if (status === 401) {
        this.snackbarErrorService.open('Erro, refaça o login!', 'Erro', duration);
      }
    }
  }

  public mask(text, mask) {
    if (!text) {
      return text;
    }

    text = text.toString();
    const er = /[^0-9/ (),.-]/;
    er.lastIndex = 0;

    if (er.test(text)) {
      return text.substring(0, text.length - 1);
    }
    let booleanMask: boolean;
    const exp = /\-|\.|\/|\(|\)| /g;
    const onlyNumbers = text.toString().replace(exp, '');
    let textPosition = 0;
    let newText = '';
    let maskSize = onlyNumbers.length;
    for (let i = 0; i <= maskSize; i++) {
      booleanMask =
        mask.charAt(i) === '-' ||
        mask.charAt(i) === '.' ||
        mask.charAt(i) === '/';
      booleanMask =
        booleanMask ||
        mask.charAt(i) === '(' ||
        mask.charAt(i) === ')' ||
        mask.charAt(i) === ' ';
      if (booleanMask) {
        newText += mask.charAt(i);
        maskSize++;
      } else {
        newText += onlyNumbers.charAt(textPosition);
        textPosition++;
      }
    }
    return newText;
  }

  public maskCpfCnpj(v) {

    if (!v) {
      return v;
    }
    // Remove tudo o que não é dígito
    v = v.replace(/\D/g, '');

    if (v.length < 14) {
      // CPF

      // Coloca um ponto entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{3})(\d)/, '$1.$2');

      // Coloca um ponto entre o terceiro e o quarto dígitos
      // de novo (para o segundo bloco de números)
      v = v.replace(/(\d{3})(\d)/, '$1.$2');

      // Coloca um hífen entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else {
      // CNPJ

      // Coloca ponto entre o segundo e o terceiro dígitos
      v = v.replace(/^(\d{2})(\d)/, '$1.$2');

      // Coloca ponto entre o quinto e o sexto dígitos
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');

      // Coloca uma barra entre o oitavo e o nono dígitos
      v = v.replace(/\.(\d{3})(\d)/, '.$1/$2');

      // Coloca um hífen depois do bloco de quatro dígitos
      v = v.replace(/(\d{4})(\d)/, '$1-$2');
    }
    return v;
  }

  public toast(message: string, type: string, duration = 4, verticalPosition: MatSnackBarVerticalPosition = 'bottom') {
    duration = duration * 1000;
    this.snackBar.open(message, type, { duration, verticalPosition });
  }

  public phoneFormat(phone: string, removePrefixOnly?: boolean): string {
    if (!phone) return phone;

    let normalized = phone.replace(/[\s()-]/g, '');

    if (normalized.startsWith('+55')) {
      normalized = normalized.replace('+55', '');
      if (removePrefixOnly) return normalized;

      normalized = normalized.replace(/\D/g, '');
      normalized = normalized.replace(/^(\d{2})(\d)/, '($1) $2');
      normalized = normalized.replace(/(\d{5})(\d)/, '$1-$2');
      return normalized;
    }

    return phone;
  }

  public isIOS() {
    return !!(
      window &&
      typeof this.Window.webkit !== 'undefined' &&
      this.Window.webkit.messageHandlers &&
      this.Window.webkit.messageHandlers.NativeInterface
    );
  }

  public isMobile() {
    if (
      window &&
      typeof this.Window.NativeInterface !== 'undefined' &&
      this.Window.NativeInterface
    ) {
      return true;
    } else if (
      window &&
      typeof this.Window.webkit !== 'undefined' &&
      this.Window.webkit.messageHandlers &&
      this.Window.webkit.messageHandlers.NativeInterface
    ) {
      return true;
    }

    return false;
  }

  public isDesktop(minWidth = 600) {
    return window.innerWidth >= minWidth;
  }

  /**
   * Returns the device the user's currently on
   */
  public getDevice(): string {
    if (this.isIOS()) {
      return 'iOS';
    }
    if (this.isMobile()) {
      return 'Android';
    }
    if (!this.isDesktop()) {
      return 'Mobile';
    }
    return 'Desktop';
  }

  stringFormat(value: string) {
    const resp = {
      UPDATE: 'atualizou',
      INSERT: 'criou',
      DELETE: 'removeu',
      ACTIVE: 'Ativo',
      INACTIVE: 'Inativo',
      MALE: 'Masculino',
      FEMALE: 'Feminino',
      MAR: 'Mar Saúde',
      OTHERS: 'Outros',
      INITIAL: 'Inicial',
      RETURN: 'Retorno',
      HUMAN_RESOURCES: 'Recursos Humanos',
      HEALTH_OPERATOR: 'Operadora de saúde',
      BROKER: 'Corretor',
      RATING_YES: 'Sim',
      RATING_NO: 'Não',
      PATIENT_EXAM_REQUEST_REASONS: 'Motivos dos exames',
      PATIENT_EXAM_REQUEST_INSTRUCTIONS: 'Preparo dos exames',
      PATIENT_HUMAN_SUPPORT: 'Suporte humano',
      PATIENT_EXAM_REQUEST_DOWNLOAD: 'Baixar pedido',
      PATIENT_PREVIOUS_EXAMS: 'Exames prévios',
      PATIENT_HOME: 'Página inicial',
      PATIENT_PERFORMED_EXAM_UPLOAD: 'Enviar resultados',
      PATIENT_SUMMARY: 'Relatório de saúde',
      PATIENT_PERFORMED_EXAM_DOWNLOAD: 'Baixar resultados',
      BAD_CONTENT: 'Conteúdo não encontrado ou de baixa qualidade',
      NO_EXAMS: 'Sem exames',
      INCOMPLETE_RESULTS: 'Incompleto',
      ALL_RESULTS: 'Completo',
      ERROR: 'Erro',
      SUCCESS: 'Sucesso',
      NO_CONTENT: 'Sem conteúdo',
      DOCUMENT_AI_IMAGE: 'OCR',
      DOCUMENT_AI_PDF: 'texto',
      PROBABLY_BLOOD_PRESSURE_EQUIPMENT: 'provável equipamento de medida de pressão',
      PROBABLY_MAR_EXAM_REQUEST: 'provável pedido de exames Mar Saúde',
      OVERALL_QUALITY: 'qualidade geral',
      CHAR_COUNT: 'página com poucos caracteres',
      DEFECT_TOO_MUCH_SLOPE: 'página torta',
      DEFECT_BLURRY: 'página borrada',
      DEFECT_NOISY: 'página com ruído',
      DEFECT_DARK: 'página muito escura',
      DEFECT_FAINT: 'texto apagado',
      DEFECT_TEXT_TOO_SMALL: 'texto muito pequeno',
      DEFECT_DOCUMENT_CUTOFF: 'página cortada',
      DEFECT_TEXT_CUTOFF: 'texto cortado',
      DEFECT_GLARE: 'página com muito brilho',
    };
    return resp[value] || value;
  }
}

export interface ListDDI {
  country: string;
  iso: string;
  flagImg: string;
  ddi: string;
}


const LIST_DDI: ListDDI[] = [
  {
    country: 'Brasil',
    iso: 'BR',
    flagImg: 'assets/image/flags/br.webp',
    ddi: '+55'
  },
  {
    country: 'Afghanistão',
    iso: 'AF',
    flagImg: 'assets/image/flags/af.webp',
    ddi: '+93'
  },
  {
    country: 'África do Sul',
    iso: 'ZA',
    flagImg: 'assets/image/flags/za.webp',
    ddi: '+27'
  },
  {
    country: 'Albânia',
    iso: 'AL',
    flagImg: 'assets/image/flags/al.webp',
    ddi: '+355'
  },
  {
    country: 'Alemanha',
    iso: 'DE',
    flagImg: 'assets/image/flags/de.webp',
    ddi: '+49'
  },
  {
    country: 'Andora',
    iso: 'AD',
    flagImg: 'assets/image/flags/ad.webp',
    ddi: '+376'
  },
  {
    country: 'Angola',
    iso: 'AO',
    flagImg: 'assets/image/flags/ao.webp',
    ddi: '+244'
  },
  {
    country: 'Anguilla',
    iso: 'AI',
    flagImg: 'assets/image/flags/ai.webp',
    ddi: '+1264'
  },
  {
    country: 'Antarctica',
    iso: 'AQ',
    flagImg: 'assets/image/flags/aq.webp',
    ddi: '+672'
  },
  {
    country: 'Antígua e Barbuda',
    iso: 'AG',
    flagImg: 'assets/image/flags/ag.webp',
    ddi: '+1268'
  },
  {
    country: 'Argentina',
    iso: 'AR',
    flagImg: 'assets/image/flags/ar.webp',
    ddi: '+54'
  },
  {
    country: 'Argélia',
    iso: 'DZ',
    flagImg: 'assets/image/flags/dz.webp',
    ddi: '+213'
  },
  {
    country: 'Arménia',
    iso: 'AM',
    flagImg: 'assets/image/flags/am.webp',
    ddi: '+374'
  },
  {
    country: 'Aruba',
    iso: 'AW',
    flagImg: 'assets/image/flags/aw.webp',
    ddi: '+297'
  },
  {
    country: 'Arábia Saudita',
    iso: 'SA',
    flagImg: 'assets/image/flags/sa.webp',
    ddi: '+966'
  },
  {
    country: 'Austrália',
    iso: 'AU',
    flagImg: 'assets/image/flags/au.webp',
    ddi: '+61'
  },
  {
    country: 'Áustria',
    iso: 'AT',
    flagImg: 'assets/image/flags/at.webp',
    ddi: '+43'
  },
  {
    country: 'Azerbaijão',
    iso: 'AZ',
    flagImg: 'assets/image/flags/az.webp',
    ddi: '+994'
  },
  {
    country: 'Bahamas',
    iso: 'BS',
    flagImg: 'assets/image/flags/bs.webp',
    ddi: '+1242'
  },
  {
    country: 'Bahrein',
    iso: 'BH',
    flagImg: 'assets/image/flags/bh.webp',
    ddi: '+973'
  },
  {
    country: 'Bangladesh',
    iso: 'BD',
    flagImg: 'assets/image/flags/bd.webp',
    ddi: '+880'
  },
  {
    country: 'Barbados',
    iso: 'BB',
    flagImg: 'assets/image/flags/bb.webp',
    ddi: '+1246'
  },
  {
    country: 'Bélgica',
    iso: 'BE',
    flagImg: 'assets/image/flags/be.webp',
    ddi: '+32'
  },
  {
    country: 'Belize',
    iso: 'BZ',
    flagImg: 'assets/image/flags/bz.webp',
    ddi: '+501'
  },
  {
    country: 'Benim',
    iso: 'BJ',
    flagImg: 'assets/image/flags/bj.webp',
    ddi: '+229'
  },
  {
    country: 'Bermuda',
    iso: 'BM',
    flagImg: 'assets/image/flags/bm.webp',
    ddi: '+1441'
  },
  {
    country: 'Butão',
    iso: 'BT',
    flagImg: 'assets/image/flags/bt.webp',
    ddi: '+975'
  },
  {
    country: 'Bielorrússia',
    iso: 'BY',
    flagImg: 'assets/image/flags/by.webp',
    ddi: '+375'
  },
  {
    country: 'Bolívia',
    iso: 'BO',
    flagImg: 'assets/image/flags/bo.webp',
    ddi: '+591'
  },
  {
    country: 'Bósnia e Herzegovina',
    iso: 'BA',
    flagImg: 'assets/image/flags/ba.webp',
    ddi: '+387'
  },
  {
    country: 'Botswana',
    iso: 'BW',
    flagImg: 'assets/image/flags/bw.webp',
    ddi: '+267'
  },
  {
    country: 'British Indian Ocean Territory',
    iso: 'IO',
    flagImg: 'assets/image/flags/io.webp',
    ddi: '+246'
  },
  {
    country: 'Brunei',
    iso: 'BN',
    flagImg: 'assets/image/flags/bn.webp',
    ddi: '+673'
  },
  {
    country: 'Bulgária',
    iso: 'BG',
    flagImg: 'assets/image/flags/bg.webp',
    ddi: '+359'
  },
  {
    country: 'Burkina Faso',
    iso: 'BF',
    flagImg: 'assets/image/flags/bf.webp',
    ddi: '+226'
  },
  {
    country: 'Myanmar (Burma)',
    iso: 'MM',
    flagImg: 'assets/image/flags/mm.webp',
    ddi: '+95'
  },
  {
    country: 'Burundi',
    iso: 'BI',
    flagImg: 'assets/image/flags/bi.webp',
    ddi: '+257'
  },
  {
    country: 'Camarões',
    iso: 'CM',
    flagImg: 'assets/image/flags/cm.webp',
    ddi: '+237'
  },
  {
    country: 'Cabo Verde',
    iso: 'CV',
    flagImg: 'assets/image/flags/cv.webp',
    ddi: '+238'
  },
  {
    country: 'Camboja',
    iso: 'KH',
    flagImg: 'assets/image/flags/kh.webp',
    ddi: '+855'
  },
  {
    country: 'Canadá',
    iso: 'CA',
    flagImg: 'assets/image/flags/ca.webp',
    ddi: '+1'
  },
  {
    country: 'Catar',
    iso: 'QA',
    flagImg: 'assets/image/flags/qa.webp',
    ddi: '+974'
  },
  {
    country: 'Chad',
    iso: 'TD',
    flagImg: 'assets/image/flags/td.webp',
    ddi: '+235'
  },
  {
    country: 'Chile',
    iso: 'CL',
    flagImg: 'assets/image/flags/cl.webp',
    ddi: '+56'
  },
  {
    country: 'China',
    iso: 'CN',
    flagImg: 'assets/image/flags/cn.webp',
    ddi: '+86'
  },
  {
    country: 'Chipre',
    iso: 'CY',
    flagImg: 'assets/image/flags/cy.webp',
    ddi: '+357'
  },
  {
    country: 'Christmas Island',
    iso: 'CX',
    flagImg: 'assets/image/flags/cx.webp',
    ddi: '+61'
  },
  {
    country: 'Cingapura',
    iso: 'SG',
    flagImg: 'assets/image/flags/sg.webp',
    ddi: '+65'
  },
  {
    country: 'Colômbia',
    iso: 'CO',
    flagImg: 'assets/image/flags/co.webp',
    ddi: '+57'
  },
  {
    country: 'Comores',
    iso: 'KM',
    flagImg: 'assets/image/flags/km.webp',
    ddi: '+269'
  },
  {
    country: 'Coreia do Norte',
    iso: 'KP',
    flagImg: 'assets/image/flags/kp.webp',
    ddi: '+850'
  },
  {
    country: 'Coreia do Sul',
    iso: 'KR',
    flagImg: 'assets/image/flags/kr.webp',
    ddi: '+82'
  },
  {
    country: 'Costa do Marfim',
    iso: 'CI',
    flagImg: 'assets/image/flags/ci.webp',
    ddi: '+225'
  },
  {
    country: 'Costa Rica',
    iso: 'CR',
    flagImg: 'assets/image/flags/cr.webp',
    ddi: '+506'
  },
  {
    country: 'Croácia',
    iso: 'HR',
    flagImg: 'assets/image/flags/hr.webp',
    ddi: '+385'
  },
  {
    country: 'Cuba',
    iso: 'CU',
    flagImg: 'assets/image/flags/cu.webp',
    ddi: '+53'
  },
  {
    country: 'Dinamarca',
    iso: 'DK',
    flagImg: 'assets/image/flags/dk.webp',
    ddi: '+45'
  },
  {
    country: 'Djibouti',
    iso: 'DJ',
    flagImg: 'assets/image/flags/dj.webp',
    ddi: '+253'
  },
  {
    country: 'Dominica',
    iso: 'DM',
    flagImg: 'assets/image/flags/dm.webp',
    ddi: '+1767'
  },
  {
    country: 'Egito',
    iso: 'EG',
    flagImg: 'assets/image/flags/eg.webp',
    ddi: '+20'
  },
  {
    country: 'El Salvador',
    iso: 'SV',
    flagImg: 'assets/image/flags/sv.webp',
    ddi: '+503'
  },
  {
    country: 'Emirados Árabes Unidos',
    iso: 'AE',
    flagImg: 'assets/image/flags/ae.webp',
    ddi: '+971'
  },
  {
    country: 'Equador',
    iso: 'EC',
    flagImg: 'assets/image/flags/ec.webp',
    ddi: '+593'
  },
  {
    country: 'Eritreia',
    iso: 'ER',
    flagImg: 'assets/image/flags/er.webp',
    ddi: '+291'
  },
  {
    country: 'Estónia',
    iso: 'EE',
    flagImg: 'assets/image/flags/ee.webp',
    ddi: '+372'
  },
  {
    country: 'Espanha',
    iso: 'ES',
    flagImg: 'assets/image/flags/es.webp',
    ddi: '+34'
  },
  {
    country: 'Etiópia',
    iso: 'ET',
    flagImg: 'assets/image/flags/et.webp',
    ddi: '+251'
  },
  {
    country: 'Fiji',
    iso: 'FJ',
    flagImg: 'assets/image/flags/fj.webp',
    ddi: '+679'
  },
  {
    country: 'Finlândia',
    iso: 'FI',
    flagImg: 'assets/image/flags/fi.webp',
    ddi: '+358'
  },
  {
    country: 'França',
    iso: 'FR',
    flagImg: 'assets/image/flags/fr.webp',
    ddi: '+33'
  },
  {
    country: 'Gabão',
    iso: 'GA',
    flagImg: 'assets/image/flags/ga.webp',
    ddi: '+241'
  },
  {
    country: 'Gâmbia',
    iso: 'GM',
    flagImg: 'assets/image/flags/gm.webp',
    ddi: '+220'
  },
  {
    country: 'Faixa de Gaza (Palestina)',
    iso: 'PS',
    flagImg: 'assets/image/flags/ps.webp',
    ddi: '+970'
  },
  {
    country: 'Geórgia',
    iso: 'GE',
    flagImg: 'assets/image/flags/ge.webp',
    ddi: '+995'
  },
  {
    country: 'Gana',
    iso: 'GH',
    flagImg: 'assets/image/flags/gh.webp',
    ddi: '+233'
  },
  {
    country: 'Gibraltar',
    iso: 'GI',
    flagImg: 'assets/image/flags/gi.webp',
    ddi: '+350'
  },
  {
    country: 'Grécia',
    iso: 'GR',
    flagImg: 'assets/image/flags/gr.webp',
    ddi: '+30'
  },
  {
    country: 'Groelândia',
    iso: 'GL',
    flagImg: 'assets/image/flags/gl.webp',
    ddi: '+299'
  },
  {
    country: 'Granada',
    iso: 'GD',
    flagImg: 'assets/image/flags/gd.webp',
    ddi: '+1473'
  },
  {
    country: 'Guam',
    iso: 'GU',
    flagImg: 'assets/image/flags/gu.webp',
    ddi: '+1671'
  },
  {
    country: 'Guatemala',
    iso: 'GT',
    flagImg: 'assets/image/flags/gt.webp',
    ddi: '+502'
  },
  {
    country: 'Guiana',
    iso: 'GY',
    flagImg: 'assets/image/flags/gy.webp',
    ddi: '+592'
  },
  {
    country: 'Guiné',
    iso: 'GN',
    flagImg: 'assets/image/flags/gn.webp',
    ddi: '+224'
  },
  {
    country: 'Guiné Equatorial',
    iso: 'GQ',
    flagImg: 'assets/image/flags/gq.webp',
    ddi: '+240'
  },
  {
    country: 'Guiné-Bissau',
    iso: 'GW',
    flagImg: 'assets/image/flags/gw.webp',
    ddi: '+245'
  },
  {
    country: 'Haiti',
    iso: 'HT',
    flagImg: 'assets/image/flags/ht.webp',
    ddi: '+509'
  },
  {
    country: 'Honduras',
    iso: 'HN',
    flagImg: 'assets/image/flags/hn.webp',
    ddi: '+504'
  },
  {
    country: 'Hong Kong',
    iso: 'HK',
    flagImg: 'assets/image/flags/hk.webp',
    ddi: '+852'
  },
  {
    country: 'Hungria',
    iso: 'HU',
    flagImg: 'assets/image/flags/hu.webp',
    ddi: '+36'
  },
  {
    country: 'Islândia',
    iso: 'IS',
    flagImg: 'assets/image/flags/is.webp',
    ddi: '+354'
  },
  {
    country: 'Ilhas Cayman',
    iso: 'KY',
    flagImg: 'assets/image/flags/ky.webp',
    ddi: '+1345'
  },
  {
    country: 'Ilhas Cocos (Keeling)',
    iso: 'CC',
    flagImg: 'assets/image/flags/cc.webp',
    ddi: '+61'
  },
  {
    country: 'Ilha de Man',
    iso: 'IM',
    flagImg: 'assets/image/flags/im.webp',
    ddi: '+44'
  },
  {
    country: 'Ilhas Cook',
    iso: 'CK',
    flagImg: 'assets/image/flags/ck.webp',
    ddi: '+682'
  },
  {
    country: 'Ilhas Falkland (Malvinas)',
    iso: 'FK',
    flagImg: 'assets/image/flags/fk.webp',
    ddi: '+500'
  },
  {
    country: 'Ilhas Feroé',
    iso: 'FO',
    flagImg: 'assets/image/flags/fo.webp',
    ddi: '+298'
  },
  {
    country: 'Ilhas Mariana do Norte',
    iso: 'MP',
    flagImg: 'assets/image/flags/mp.webp',
    ddi: '+1670'
  },
  {
    country: 'Ilhas Marshall',
    iso: 'MH',
    flagImg: 'assets/image/flags/mh.webp',
    ddi: '+692'
  },
  {
    country: 'Ilha Norfolk',
    iso: 'NF',
    flagImg: 'assets/image/flags/nf.webp',
    ddi: '+672'
  },
  {
    country: 'Ilhas Pitcairn',
    iso: 'PN',
    flagImg: 'assets/image/flags/pn.webp',
    ddi: '+870'
  },
  {
    country: 'Ilhas Salomão',
    iso: 'SB',
    flagImg: 'assets/image/flags/sb.webp',
    ddi: '+677'
  },
  {
    country: 'Ilhas Turcas e Caicos',
    iso: 'TC',
    flagImg: 'assets/image/flags/tc.webp',
    ddi: '+1649'
  },
  {
    country: 'Ilhas Virgens Americanas',
    iso: 'VI',
    flagImg: 'assets/image/flags/vi.webp',
    ddi: '+1340'
  },
  {
    country: 'Ilhas Virgens Britânicas',
    iso: 'VG',
    flagImg: 'assets/image/flags/vg.webp',
    ddi: '+1284'
  },
  {
    country: 'India',
    iso: 'IN',
    flagImg: 'assets/image/flags/in.webp',
    ddi: '+91'
  },
  {
    country: 'Indonésia',
    iso: 'ID',
    flagImg: 'assets/image/flags/id.webp',
    ddi: '+62'
  },
  {
    country: 'Inglaterra (Reino Unido)',
    iso: 'GB',
    flagImg: 'assets/image/flags/gb.webp',
    ddi: '+44'
  },
  {
    country: 'Irã',
    iso: 'IR',
    flagImg: 'assets/image/flags/ir.webp',
    ddi: '+98'
  },
  {
    country: 'Iraque',
    iso: 'IQ',
    flagImg: 'assets/image/flags/iq.webp',
    ddi: '+964'
  },
  {
    country: 'Irlanda',
    iso: 'IE',
    flagImg: 'assets/image/flags/ie.webp',
    ddi: '+353'
  },
  {
    country: 'Israel',
    iso: 'IL',
    flagImg: 'assets/image/flags/il.webp',
    ddi: '+972'
  },
  {
    country: 'Itália',
    iso: 'IT',
    flagImg: 'assets/image/flags/it.webp',
    ddi: '+39'
  },
  {
    country: 'Jamaica',
    iso: 'JM',
    flagImg: 'assets/image/flags/jm.webp',
    ddi: '+1876'
  },
  {
    country: 'Japão',
    iso: 'JP',
    flagImg: 'assets/image/flags/jp.webp',
    ddi: '+81'
  },
  {
    country: 'Jersey',
    iso: 'JE',
    flagImg: 'assets/image/flags/je.webp',
    ddi: '+44'
  },
  {
    country: 'Jordânia',
    iso: 'JO',
    flagImg: 'assets/image/flags/jo.webp',
    ddi: '+962'
  },
  {
    country: 'Cazaquistão',
    iso: 'KZ',
    flagImg: 'assets/image/flags/kz.webp',
    ddi: '+7'
  },
  {
    country: 'Quénia (Kenya)',
    iso: 'KE',
    flagImg: 'assets/image/flags/ke.webp',
    ddi: '+254'
  },
  {
    country: 'Kiribati',
    iso: 'KI',
    flagImg: 'assets/image/flags/ki.webp',
    ddi: '+686'
  },
  {
    country: 'Kosovo',
    iso: 'XK',
    flagImg: 'assets/image/flags/xk.webp',
    ddi: '+383'
  },
  {
    country: 'Kuwait',
    iso: 'KW',
    flagImg: 'assets/image/flags/kw.webp',
    ddi: '+965'
  },
  {
    country: 'Quirguistão',
    iso: 'KG',
    flagImg: 'assets/image/flags/kg.webp',
    ddi: '+996'
  },
  {
    country: 'Laos',
    iso: 'LA',
    flagImg: 'assets/image/flags/la.webp',
    ddi: '+856'
  },
  {
    country: 'Letônia',
    iso: 'LV',
    flagImg: 'assets/image/flags/lv.webp',
    ddi: '+371'
  },
  {
    country: 'Líbano',
    iso: 'LB',
    flagImg: 'assets/image/flags/lb.webp',
    ddi: '+961'
  },
  {
    country: 'Lesoto',
    iso: 'LS',
    flagImg: 'assets/image/flags/ls.webp',
    ddi: '+266'
  },
  {
    country: 'Libéria',
    iso: 'LR',
    flagImg: 'assets/image/flags/lr.webp',
    ddi: '+231'
  },
  {
    country: 'Líbia',
    iso: 'LY',
    flagImg: 'assets/image/flags/ly.webp',
    ddi: '+218'
  },
  {
    country: 'Liechtenstein',
    iso: 'LI',
    flagImg: 'assets/image/flags/li.webp',
    ddi: '+423'
  },
  {
    country: 'Lituânia',
    iso: 'LT',
    flagImg: 'assets/image/flags/lt.webp',
    ddi: '+370'
  },
  {
    country: 'Luxemburgo',
    iso: 'LU',
    flagImg: 'assets/image/flags/lu.webp',
    ddi: '+352'
  },
  {
    country: 'Macau',
    iso: 'MO',
    flagImg: 'assets/image/flags/mo.webp',
    ddi: '+853'
  },
  {
    country: 'Macedónia',
    iso: 'MK',
    flagImg: 'assets/image/flags/mk.webp',
    ddi: '+389'
  },
  {
    country: 'Madagáscar',
    iso: 'MG',
    flagImg: 'assets/image/flags/mg.webp',
    ddi: '+261'
  },
  {
    country: 'Malawi',
    iso: 'MW',
    flagImg: 'assets/image/flags/mw.webp',
    ddi: '+265'
  },
  {
    country: 'Malásia',
    iso: 'MY',
    flagImg: 'assets/image/flags/my.webp',
    ddi: '+60'
  },
  {
    country: 'Maldivas',
    iso: 'MV',
    flagImg: 'assets/image/flags/mv.webp',
    ddi: '+960'
  },
  {
    country: 'Mali',
    iso: 'ML',
    flagImg: 'assets/image/flags/ml.webp',
    ddi: '+223'
  },
  {
    country: 'Malta',
    iso: 'MT',
    flagImg: 'assets/image/flags/mt.webp',
    ddi: '+356'
  },
  {
    country: 'Mauritânia',
    iso: 'MR',
    flagImg: 'assets/image/flags/mr.webp',
    ddi: '+222'
  },
  {
    country: 'Maurícia',
    iso: 'MU',
    flagImg: 'assets/image/flags/mu.webp',
    ddi: '+230'
  },
  {
    country: 'Mayotte',
    iso: 'YT',
    flagImg: 'assets/image/flags/yt.webp',
    ddi: '+262'
  },
  {
    country: 'México',
    iso: 'MX',
    flagImg: 'assets/image/flags/mx.webp',
    ddi: '+52'
  },
  {
    country: 'Micronésia',
    iso: 'FM',
    flagImg: 'assets/image/flags/fm.webp',
    ddi: '+691'
  },
  {
    country: 'Moldávia',
    iso: 'MD',
    flagImg: 'assets/image/flags/md.webp',
    ddi: '+373'
  },
  {
    country: 'Monaco',
    iso: 'MC',
    flagImg: 'assets/image/flags/mc.webp',
    ddi: '+377'
  },
  {
    country: 'Mongólia',
    iso: 'MN',
    flagImg: 'assets/image/flags/mn.webp',
    ddi: '+976'
  },
  {
    country: 'Montenegro',
    iso: 'ME',
    flagImg: 'assets/image/flags/me.webp',
    ddi: '+382'
  },
  {
    country: 'Montserrat',
    iso: 'MS',
    flagImg: 'assets/image/flags/ms.webp',
    ddi: '+1664'
  },
  {
    country: 'Marrocos',
    iso: 'MA',
    flagImg: 'assets/image/flags/ma.webp',
    ddi: '+212'
  },
  {
    country: 'Moçambique',
    iso: 'MZ',
    flagImg: 'assets/image/flags/mz.webp',
    ddi: '+258'
  },
  {
    country: 'Namíbia',
    iso: 'NA',
    flagImg: 'assets/image/flags/na.webp',
    ddi: '+264'
  },
  {
    country: 'Nauru',
    iso: 'NR',
    flagImg: 'assets/image/flags/nr.webp',
    ddi: '+674'
  },
  {
    country: 'Nepal',
    iso: 'NP',
    flagImg: 'assets/image/flags/np.webp',
    ddi: '+977'
  },
  {
    country: 'Netherlands Antilles',
    iso: 'AN',
    flagImg: 'assets/image/flags/an.webp',
    ddi: '+599'
  },
  {
    country: 'Nova Caledônia',
    iso: 'NC',
    flagImg: 'assets/image/flags/nc.webp',
    ddi: '+687'
  },
  {
    country: 'Nova Zelândia',
    iso: 'NZ',
    flagImg: 'assets/image/flags/nz.webp',
    ddi: '+64'
  },
  {
    country: 'Nicaragua',
    iso: 'NI',
    flagImg: 'assets/image/flags/ni.webp',
    ddi: '+505'
  },
  {
    country: 'Níger',
    iso: 'NE',
    flagImg: 'assets/image/flags/ne.webp',
    ddi: '+227'
  },
  {
    country: 'Nigéria',
    iso: 'NG',
    flagImg: 'assets/image/flags/ng.webp',
    ddi: '+234'
  },
  {
    country: 'Niue',
    iso: 'NU',
    flagImg: 'assets/image/flags/nu.webp',
    ddi: '+683'
  },
  {
    country: 'Noruega',
    iso: 'NO',
    flagImg: 'assets/image/flags/no.webp',
    ddi: '+47'
  },
  {
    country: 'Omã',
    iso: 'OM',
    flagImg: 'assets/image/flags/om.webp',
    ddi: '+968'
  },
  {
    country: 'Países Baixos',
    iso: 'NL',
    flagImg: 'assets/image/flags/nl.webp',
    ddi: '+31'
  },
  {
    country: 'Paquistão',
    iso: 'PK',
    flagImg: 'assets/image/flags/pk.webp',
    ddi: '+92'
  },
  {
    country: 'Palau',
    iso: 'PW',
    flagImg: 'assets/image/flags/pw.webp',
    ddi: '+680'
  },
  {
    country: 'Panamá',
    iso: 'PA',
    flagImg: 'assets/image/flags/pa.webp',
    ddi: '+507'
  },
  {
    country: 'Papua-Nova Guiné',
    iso: 'PG',
    flagImg: 'assets/image/flags/pg.webp',
    ddi: '+675'
  },
  {
    country: 'Paraguai',
    iso: 'PY',
    flagImg: 'assets/image/flags/py.webp',
    ddi: '+595'
  },
  {
    country: 'Peru',
    iso: 'PE',
    flagImg: 'assets/image/flags/pe.webp',
    ddi: '+51'
  },
  {
    country: 'Filipinas',
    iso: 'PH',
    flagImg: 'assets/image/flags/ph.webp',
    ddi: '+63'
  },
  {
    country: 'Polónia',
    iso: 'PL',
    flagImg: 'assets/image/flags/pl.webp',
    ddi: '+48'
  },
  {
    country: 'Polinésia Francesa',
    iso: 'PF',
    flagImg: 'assets/image/flags/pf.webp',
    ddi: '+689'
  },
  {
    country: 'Portugal',
    iso: 'PT',
    flagImg: 'assets/image/flags/pt.webp',
    ddi: '+351'
  },
  {
    country: 'Porto Rico',
    iso: 'PR',
    flagImg: 'assets/image/flags/pr.webp',
    ddi: '+1'
  },
  {
    country: 'República do Congo',
    iso: 'CG',
    flagImg: 'assets/image/flags/cg.webp',
    ddi: '+242'
  },
  {
    country: 'República Democrática do Congo',
    iso: 'CD',
    flagImg: 'assets/image/flags/cd.webp',
    ddi: '+243'
  },
  {
    country: 'República Centro-Africana',
    iso: 'CF',
    flagImg: 'assets/image/flags/cf.webp',
    ddi: '+236'
  },
  {
    country: 'República Checa',
    iso: 'CZ',
    flagImg: 'assets/image/flags/cz.webp',
    ddi: '+420'
  },
  {
    country: 'República Dominicana',
    iso: 'DO',
    flagImg: 'assets/image/flags/do.webp',
    ddi: '+1809'
  },
  {
    country: 'República Dominicana',
    iso: 'DO',
    flagImg: 'assets/image/flags/do.webp',
    ddi: '+1829'
  },
  {
    country: 'República Dominicana',
    iso: 'DO',
    flagImg: 'assets/image/flags/do.webp',
    ddi: '+1849'
  },
  {
    country: 'Roménia',
    iso: 'RO',
    flagImg: 'assets/image/flags/ro.webp',
    ddi: '+40'
  },
  {
    country: 'Ruanda',
    iso: 'RW',
    flagImg: 'assets/image/flags/rw.webp',
    ddi: '+250'
  },
  {
    country: 'Rússia',
    iso: 'RU',
    flagImg: 'assets/image/flags/ru.webp',
    ddi: '+7'
  },
  {
    country: 'Saint Barthelemy',
    iso: 'BL',
    flagImg: 'assets/image/flags/bl.webp',
    ddi: '+590'
  },
  {
    country: 'Samoa',
    iso: 'WS',
    flagImg: 'assets/image/flags/ws.webp',
    ddi: '+685'
  },
  {
    country: 'Samoa Americana',
    iso: 'AS',
    flagImg: 'assets/image/flags/as.webp',
    ddi: '+1684'
  },
  {
    country: 'San Marino',
    iso: 'SM',
    flagImg: 'assets/image/flags/sm.webp',
    ddi: '+378'
  },
  {
    country: 'Sao Tome e Principe',
    iso: 'ST',
    flagImg: 'assets/image/flags/st.webp',
    ddi: '+239'
  },
  {
    country: 'Senegal',
    iso: 'SN',
    flagImg: 'assets/image/flags/sn.webp',
    ddi: '+221'
  },
  {
    country: 'Serbia',
    iso: 'RS',
    flagImg: 'assets/image/flags/rs.webp',
    ddi: '+381'
  },
  {
    country: 'Serra Leoa',
    iso: 'SL',
    flagImg: 'assets/image/flags/sl.webp',
    ddi: '+232'
  },
  {
    country: 'Seychelles',
    iso: 'SC',
    flagImg: 'assets/image/flags/sc.webp',
    ddi: '+248'
  },
  {
    country: 'Slovakia',
    iso: 'SK',
    flagImg: 'assets/image/flags/sk.webp',
    ddi: '+421'
  },
  {
    country: 'Slovenia',
    iso: 'SI',
    flagImg: 'assets/image/flags/si.webp',
    ddi: '+386'
  },
  {
    country: 'Somalia',
    iso: 'SO',
    flagImg: 'assets/image/flags/so.webp',
    ddi: '+252'
  },
  {
    country: 'Sri Lanka',
    iso: 'LK',
    flagImg: 'assets/image/flags/lk.webp',
    ddi: '+94'
  },
  {
    country: 'Saint Helena',
    iso: 'SH',
    flagImg: 'assets/image/flags/sh.webp',
    ddi: '+290'
  },
  {
    country: 'Saint Kitts and Nevis',
    iso: 'KN',
    flagImg: 'assets/image/flags/kn.webp',
    ddi: '+1869'
  },
  {
    country: 'Saint Lucia',
    iso: 'LC',
    flagImg: 'assets/image/flags/lc.webp',
    ddi: '+1758'
  },
  {
    country: 'Saint Martin',
    iso: 'MF',
    flagImg: 'assets/image/flags/mf.webp',
    ddi: '+590'
  },
  {
    country: 'Saint Pierre and Miquelon',
    iso: 'PM',
    flagImg: 'assets/image/flags/pm.webp',
    ddi: '+508'
  },
  {
    country: 'Saint Vincent and the Grenadines',
    iso: 'VC',
    flagImg: 'assets/image/flags/vc.webp',
    ddi: '+1784'
  },
  {
    country: 'Sudão',
    iso: 'SD',
    flagImg: 'assets/image/flags/sd.webp',
    ddi: '+249'
  },
  {
    country: 'Suriname',
    iso: 'SR',
    flagImg: 'assets/image/flags/sr.webp',
    ddi: '+597'
  },
  {
    country: 'Svalbard',
    iso: 'SJ',
    flagImg: 'assets/image/flags/sj.webp',
    ddi: '+47'
  },
  {
    country: 'Suazilândia',
    iso: 'SZ',
    flagImg: 'assets/image/flags/sz.webp',
    ddi: '+268'
  },
  {
    country: 'Suécia',
    iso: 'SE',
    flagImg: 'assets/image/flags/se.webp',
    ddi: '+46'
  },
  {
    country: 'Suiça',
    iso: 'CH',
    flagImg: 'assets/image/flags/ch.webp',
    ddi: '+41'
  },
  {
    country: 'Syria',
    iso: 'SY',
    flagImg: 'assets/image/flags/sy.webp',
    ddi: '+963'
  },
  {
    country: 'Taiwan',
    iso: 'TW',
    flagImg: 'assets/image/flags/tw.webp',
    ddi: '+886'
  },
  {
    country: 'Tajiquistão',
    iso: 'TJ',
    flagImg: 'assets/image/flags/tj.webp',
    ddi: '+992'
  },
  {
    country: 'Tanzânia',
    iso: 'TZ',
    flagImg: 'assets/image/flags/tz.webp',
    ddi: '+255'
  },
  {
    country: 'Timor-Leste',
    iso: 'TL',
    flagImg: 'assets/image/flags/tl.webp',
    ddi: '+670'
  },
  {
    country: 'Tailândia',
    iso: 'TH',
    flagImg: 'assets/image/flags/th.webp',
    ddi: '+66'
  },
  {
    country: 'Togo',
    iso: 'TG',
    flagImg: 'assets/image/flags/tg.webp',
    ddi: '+228'
  },
  {
    country: 'Tokelau',
    iso: 'TK',
    flagImg: 'assets/image/flags/tk.webp',
    ddi: '+690'
  },
  {
    country: 'Tonga',
    iso: 'TO',
    flagImg: 'assets/image/flags/to.webp',
    ddi: '+676'
  },
  {
    country: 'Trinidad e Tobago',
    iso: 'TT',
    flagImg: 'assets/image/flags/tt.webp',
    ddi: '+1868'
  },
  {
    country: 'Tunísia',
    iso: 'TN',
    flagImg: 'assets/image/flags/tn.webp',
    ddi: '+216'
  },
  {
    country: 'Turquemenistão',
    iso: 'TM',
    flagImg: 'assets/image/flags/tm.webp',
    ddi: '+993'
  },
  {
    country: 'Turquia',
    iso: 'TR',
    flagImg: 'assets/image/flags/tr.webp',
    ddi: '+90'
  },
  {
    country: 'Tuvalu',
    iso: 'TV',
    flagImg: 'assets/image/flags/tv.webp',
    ddi: '+688'
  },
  {
    country: 'Uganda',
    iso: 'UG',
    flagImg: 'assets/image/flags/ug.webp',
    ddi: '+256'
  },
  {
    country: 'Ucrânia',
    iso: 'UA',
    flagImg: 'assets/image/flags/ua.webp',
    ddi: '+380'
  },
  {
    country: 'Uruguai',
    iso: 'UY',
    flagImg: 'assets/image/flags/uy.webp',
    ddi: '+598'
  },
  {
    country: 'Estados Unidos (EUA)',
    iso: 'US',
    flagImg: 'assets/image/flags/us.webp',
    ddi: '+1'
  },
  {
    country: 'Uzbequistão',
    iso: 'UZ',
    flagImg: 'assets/image/flags/uz.webp',
    ddi: '+998'
  },
  {
    country: 'Vanuatu',
    iso: 'VU',
    flagImg: 'assets/image/flags/vu.webp',
    ddi: '+678'
  },
  {
    country: 'Vaticano',
    iso: 'VA',
    flagImg: 'assets/image/flags/va.webp',
    ddi: '+39'
  },
  {
    country: 'Venezuela',
    iso: 'VE',
    flagImg: 'assets/image/flags/ve.webp',
    ddi: '+58'
  },
  {
    country: 'Vietnã (Vietname)',
    iso: 'VN',
    flagImg: 'assets/image/flags/vn.webp',
    ddi: '+84'
  },
  {
    country: 'Wallis e Futuna',
    iso: 'WF',
    flagImg: 'assets/image/flags/wf.webp',
    ddi: '+681'
  },
  {
    country: 'West Bank',
    iso: 'PS',
    flagImg: 'assets/image/flags/ps.webp',
    ddi: '+970'
  },
  {
    country: 'Western Sahara',
    iso: 'EH',
    flagImg: 'assets/image/flags/eh.webp',
    ddi: '+212'
  },
  {
    country: 'Iémen (Iémen, Yemen)',
    iso: 'YE',
    flagImg: 'assets/image/flags/ye.webp',
    ddi: '+967'
  },
  {
    country: 'Zimbabwe(Zimbabué)',
    iso: 'ZW',
    flagImg: 'assets/image/flags/zw.webp',
    ddi: '+263'
  },
  {
    country: 'Zâmbia',
    iso: 'ZM',
    flagImg: 'assets/image/flags/zm.webp',
    ddi: '+260'
  }
];
